import { render } from "./MyMerchants.vue?vue&type=template&id=2b73e42a&scoped=true"
import script from "./MyMerchants.vue?vue&type=script&lang=js"
export * from "./MyMerchants.vue?vue&type=script&lang=js"

import "./MyMerchants.vue?vue&type=style&index=0&id=2b73e42a&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b73e42a"]])

export default __exports__